import {message, Modal} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SuccessLogo } from '../../asset';
import PrimaryButton from '../button/PrimaryButton';

const NotifAddSuccess = ({ visible, menu, customMessage, action }) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        visible={visible}
        closable={false}
        centered={true}
        width="298px"
        footer={null}
      >
        <div className="flex flex-col justify-center items-center gap-[9px]">
          <img src={SuccessLogo} alt="" />
          <div className="flex flex-col justify-center items-center">
            <h2 className="font-roboto text-3xl font-bold mb-[16px]">
              Success
            </h2>
            <div>
              {
                !menu ?(
                  <p className="font-roboto text-[#666666] text-center mb-[16px] font-normal text-lg">
                    {customMessage ? customMessage : "Update Successfully"}
                  </p>
                ) : (
                  <>
                    <p className="font-roboto text-[#666666] text-center font-bold text-lg">
                      {menu}
                    </p>
                    <p className="font-roboto text-[#666666] text-center mb-[16px] font-normal text-lg">
                      has been added
                    </p>
                  </>
                )
              }
            </div>
          </div>
        </div>
        <div className="content-center w-[218px] ml-4">
          <PrimaryButton
            text={t("USER_DETAIL:Ok")}
            action={action}
            styles="w-[218px] rounded-md"
          />
        </div>
      </Modal>
    </>
  );
};

export default NotifAddSuccess;